import React from "react";

export function UnitImages(p:{images:string[]}) {

  return <header>
    {p.images.map(((src,i) => <img key={i} src={src} alt={"Floor plan"}/>))}
  </header>
}